/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React, {useEffect} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MuiForm from 'components/MuiForm';

const propTypes = {
  handleFormSubmit: PropTypes.func.isRequired,
  formSchema: PropTypes.object.isRequired,
  skipStep: PropTypes.func.isRequired,
};

const DocumentVerification = ({formSchema, handleFormSubmit, skipStep}) => {
  useEffect(() => {
    const stepperContainer = document.querySelector('[class*="meta-form-stepper"]');

    if (!!stepperContainer) {
      stepperContainer.classList.add('stepper');
    }
  }, []);

  return (
    <Wrapper>
      <CardContent>
        <MuiForm
          schema={formSchema}
          onSubmit={(data) => {
            handleFormSubmit(data);
          }}
        />
      </CardContent>
    </Wrapper>
  );
};

// Styled Components
const Wrapper = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const CardContent = styled.div`
  padding: 0.5rem;
  flex: 1;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.background.secondary || '#f1f5f9'};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.brand.primary || '#7c3aed'};
    border-radius: 8px;
  }

  @media (min-width: 768px) {
    padding: 1.5rem 3rem;
  }
`;

DocumentVerification.propTypes = propTypes;

export default DocumentVerification;
